import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const TextButton = ({
  onClick,
  id,
  classNames,
  buttonText,
  icon,
  iconPosition,
  attributes,
  type = 'button'
}) => {
  return (
    <button
      id={id}
      className={classnames('text-button btn-link', classNames)}
      onClick={onClick}
      type={type}
      {...attributes}
    >
      {
        ('right' !== iconPosition) &&
        icon && <span className="button-icon margin-sm-right">{icon}</span>
      }
      {buttonText}
      {
        ('right' === iconPosition) &&
        icon && <span className="button-icon margin-sm-left">{icon}</span>
      }
    </button>
  );
};

TextButton.propTypes = {
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
  classNames: PropTypes.string,
  icon: PropTypes.object,
  id: PropTypes.string,
  attributes: PropTypes.object,
  type: PropTypes.string
};

export default TextButton;
